import React from 'react';
import Button from '../../../components/ui/Button';



const CalculationResults = ({ result, onSave }) => {
  const generateSyringeMarks = () => {
    const marks = [];
    const totalMarks = result?.syringeVolume / 5;
    for (let i = 0; i <= totalMarks; i++) {
      marks?.push(i * 5);
    }
    return marks;
  };

  const calculatePosition = () => {
    return (parseFloat(result?.unitsPerDose) / result?.syringeVolume) * 100;
  };

  return (
    <div className="p-6 rounded-xl bg-gradient-to-br from-card to-card/50 border-2 border-primary/30 shadow-[0_0_30px_rgba(0,212,255,0.2)]">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-foreground">Calculation Results</h2>
        <Button
          variant="outline"
          size="sm"
          onClick={onSave}
          iconName="Save"
          className="border-primary text-primary hover:bg-primary/10"
        >
          SAVE CALCULATION
        </Button>
      </div>

      <div className="space-y-6">
        <div className="relative">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-muted-foreground">Syringe Volume</span>
            <span className="text-lg font-bold text-primary">{result?.unitsPerDose} units</span>
          </div>
          
          <div className="relative h-12 bg-muted rounded-lg overflow-hidden">
            <div className="absolute inset-0 flex items-center justify-between px-2">
              {generateSyringeMarks()?.map((mark) => (
                <div key={mark} className="flex flex-col items-center">
                  <div className="w-px h-3 bg-muted-foreground/30" />
                  <span className="text-xs text-muted-foreground mt-1">{mark}</span>
                </div>
              ))}
            </div>
            <div
              className="absolute top-0 left-0 h-full bg-gradient-to-r from-primary/50 to-primary transition-all duration-500"
              style={{ width: `${calculatePosition()}%` }}
            />
            <div
              className="absolute top-0 h-full w-1 bg-accent shadow-[0_0_10px_rgba(245,158,11,0.8)]"
              style={{ left: `${calculatePosition()}%` }}
            />
          </div>
        </div>

        <div className="p-4 rounded-lg bg-primary/5 border border-primary/20">
          <p className="text-center text-lg font-semibold text-foreground mb-2">
            Draw <span className="text-primary">{result?.unitsPerDose} units</span> for{' '}
            <span className="text-accent">{result?.doseValue}{result?.doseUnit}</span> doses
          </p>
          <p className="text-center text-sm text-muted-foreground">
            With a concentration of <span className="text-foreground font-medium">{result?.concentration}mg/mL</span>,
            each vial contains <span className="text-foreground font-medium">{result?.totalDoses} doses</span> or{' '}
            <span className="text-foreground font-medium">{result?.dosesInMl} doses in mL</span>
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="p-4 rounded-lg bg-card border border-border">
            <p className="text-sm text-muted-foreground mb-1">Concentration</p>
            <p className="text-xl font-bold text-foreground">{result?.concentration} mg/mL</p>
          </div>
          <div className="p-4 rounded-lg bg-card border border-border">
            <p className="text-sm text-muted-foreground mb-1">Total Doses</p>
            <p className="text-xl font-bold text-foreground">{result?.totalDoses} doses</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalculationResults;